import CalculateIcon from '@mui/icons-material/Calculate';
import { Button } from '@mui/material';
import get from 'lodash/get';
import { useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';

/** Deep link into Dev Tools › Recalculate with this profile pre-filled. */
export const RecalculateButton = () => {
  const record = useRecordContext();
  const userProfileUuid = get(record, 'uuid') as string | undefined;
  const companyUuid = get(record, 'company.uuid') as string | undefined;
  if (!userProfileUuid || !companyUuid) return null;
  const search = new URLSearchParams({ companyUuid, userProfileUuid }).toString();
  return (
    <Button component={Link} to={`/dev-tools/recalculate?${search}`} startIcon={<CalculateIcon />} size="small">
      Recalculate (Dev Tools)
    </Button>
  );
};
